
import './App.css';
import ChatGpt from './components/ChatGpt';

function App() {
  return (
    <div className="App">
      <p> KELVIN-GPT</p>
       <ChatGpt  />
    </div>
  );
}

export default App;
